import React, { Component } from 'react';
import axios from 'axios';
import { Grid, Row, Col, Panel, Button, Tabs, Tab, ButtonToolbar, Breadcrumb, Input } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import { Toolbar, Data, Editors } from 'react-data-grid-addons';
import ReactDataGrid from 'react-data-grid';
import { isVAK, ROOT_URL } from '../../actions/root_url';
import { SkyLightStateless } from 'react-skylight';
import WeightChangeChooseProduct from './weightChangeChooseProduct';
import { vakDimensionsOptions, vakLogisticCarrierOptions, vakInsuranceOptions, vakUspsSignatureOptions, vakFedexSignatureOptions } from '../../utils/constant';
import ReactDOM from 'react-dom';
import { concat } from 'lodash';
import cloneDeep from 'lodash/cloneDeep';
import { roundToDecimals } from './NumberUtil';
var DropDownEditor = Editors.DropDownEditor;
var SimpleTextEditor = Editors.SimpleTextEditor;
const { Selectors } = Data;
class CustomEditor extends React.Component {
    constructor() {
        super();
        this.inputRef = null;
    }
    getStyle() {
        return {
            width: '100%'
        };
    }

    getValue() {
        let updated = {};
        updated[this.props.column.key] = this.getInputNode().value;
        return updated;
    }

    getInputNode() {
        return ReactDOM.findDOMNode(this.inputRef);
    }

    inheritContainerStyles() {
        return true;
    }
    render() {
        const {rowData} = this.props;
        if (rowData.isCustomSize) {
            return <SimpleTextEditor {...this.props} ref={ref => this.inputRef = ref}/>
        }
        return <DropDownEditor {...this.props} options={vakDimensionsOptions} ref={ref => this.inputRef = ref}/>
    }
}

class SignatureEditor extends React.Component {
    constructor() {
        super();
        this.inputRef = null;
    }
    getStyle() {
        return {
            width: '100%'
        };
    }

    getValue() {
        let updated = {};
        updated[this.props.column.key] = this.getInputNode().value;
        return updated;
    }

    getInputNode() {
        return ReactDOM.findDOMNode(this.inputRef);
    }

    inheritContainerStyles() {
        return true;
    }
    render() {
        const {rowData} = this.props;
        if (rowData.carrier.indexOf('usps') == -1) {
            return <DropDownEditor {...this.props} options={vakFedexSignatureOptions} ref={ref => this.inputRef = ref}/>
        }
        return <DropDownEditor {...this.props} options={vakUspsSignatureOptions} ref={ref => this.inputRef = ref}/>
    }
}
export class WeightChangeModalMulti extends Component {
    constructor() {
        super();
        this.state = {
            rows: [],
            selectedRows: null,
            editedRows: [],
            filters: {},
            productModalVisibility: false,
            productImportRowIdx: null,
            productImportRow: null,
            sumShippingWeight: 0,
            isLoadingPrice: false,
            isUnfreeze: false,
            isMin:false,
        }
    }

    componentDidMount() {
        this.props.fetchShippingWeightTracking(this.props.salesOrderId).then((response) => {
            if (response.data) {
                this.initializeModal(response.data.weights);
            }
        }, (err) => {
            if (err.status === 500 || err.status === 404) {
                alert("Server error, please refresh page. If problem persists, contact administrator.");
            }
        });
    }

    componentWillReceiveProps(nextProps) {
    }

    initializeModal = (array) => {
        let index = 0;
        let formatter = [];
        let sum = 0;
        if (array && array.length > 0) {
            array.map(r => {
                formatter.push({ Idx: index++, Package_Weight: r.weight, Package_Note: r.note, Tracking_Number: r.tracking, ...(isVAK ? {Dimensions: r.dimensions, Product_Details: r.product_details, isCustomSize: r.is_custom_size, carrier: r.carrier, id: r.id, shipmentId: r.shipment_id, insurance: r.insurance, insure_amount: r.insure_amount == 0 ? '' : r.insure_amount, signature: r.signature || 'none'} : {}), price: r.price || '' });
                sum += Number(r.weight);
            })
        } else {
            if(!isVAK) {
                formatter.push({ Idx: 0, Package_Weight: "", Package_Note: "", Tracking_Number: "" });
            }
        }
        this.setState({
            rows: formatter,
            sumShippingWeight: sum,
            selectedRows: [],
            editedRows: [],
        });
    }

    handleOnSave = (e) => {
        e.preventDefault();
        this.state.rows.map((r) => {
            r.recreate = false;
        });
        this.props.onSave(this.state.rows, isVAK && this.state.isUnfreeze);
    }

    handleOnSavePrint = (e) => {
        e.preventDefault();
        this.state.rows.map((r) => {
            r.recreate = false;
        });
        this.props.onSavePrint(this.state.rows);
    }
    handlePrint = (e) => {
        e.preventDefault();
        let selectIds = this.state.selectedRows.map((r) => r.id);
        this.props.onPrint(selectIds, true, this.state.isUnfreeze);
    }
    handlePackingPrint = (e) => {
        e.preventDefault();
        let selectIds = this.state.selectedRows.map((r) => r.id);
        this.props.onPackingPrint(selectIds);
    }

    handleOnRecreate = (e) => {
        e.preventDefault();
        let { selectedRows } = this.state;
        selectedRows.map((r) => {
            r.recreate = true;
        })
        this.props.onSavePrint(selectedRows);
    }

    clickNew(e) {
        e.preventDefault();
        let rows = Selectors.getRows(this.state);
        let index = rows.length;
        let newRow = { Package_Weight: null, Package_Note: null, Tracking_Number: null, Idx: index, ...(isVAK ? {Dimensions: '', Product_Details: '[]', isCustomSize: false, insurance: '', insure_amount: ''} : {}) };
        rows.push(newRow);
        let editedRows = [...this.state.editedRows];
        editedRows.push(newRow)
        this.setState({ rows, editedRows })
    }

    deleteCategory(e) {
        e.preventDefault();
        let rows = [...this.state.rows];
        let editedRows = [...this.state.editedRows];
        let index = _.findIndex(rows, { Idx: this.state.selectedRows[0].Idx })
        rows.splice(index, 1);
        index = _.findIndex(editedRows, { Idx: this.state.selectedRows[0].Idx })
        editedRows.splice(index, 1);
        this.setState({ rows, editedRows, selectedRows: [] })
    }

    handleGetLogisticPrice = row => {
        this.setState({
            isLoadingPrice: true,
        });
        axios.post(`${ROOT_URL}v1/sale/shipping/service_price/`, {
            information: [{
                order_id: this.props.salesOrderId,
                carrier: row.carrier,
                weight: row.Package_Weight,
                dimensions: row.Dimensions,
                is_custom_size: row.isCustomSize,
            }]
        },{
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        }).then(response => {
            const data = Object.values(response.data)[0][row.carrier === 'usps_priority_mail_env' ? 1 : 0];
            const rows = this.state.rows;
            rows[row.Idx].price = (data.shipmentCost || 0) + (data.otherCost || 0)
            this.setState({
                rows: [...rows],
                isLoadingPrice: false,
            });
        }).catch(() => {
            this.setState({
                isLoadingPrice: false,
            });
        })
    }

    getRowWeight = (row) => {
        let weight = 0;
        const productDetails = JSON.parse(row.Product_Details || '[]');
        productDetails.forEach(product => {
            weight += product.NetWeight * product.Quantity;
        });
        return weight;
    }

    getRowPrice = (row) => {
        let price = 0;
        const productDetails = JSON.parse(row.Product_Details || '[]');
        productDetails.forEach(product => {
            this.props.currentSalesOrderLine.map(item => {
                if(item.Product_id == product.Product_id) {
                    price += product.Quantity * item.UnitPrice;
                }
            })
        });
        return price;
    }
    getTotalShippingWeight = (rows) => {
        let sumShippingWeight = 0;
        rows.map(r => {
            if (isFinite(r.Package_Weight)) {
                sumShippingWeight += Number(r.Package_Weight);
            }
        });
        return sumShippingWeight
    }

    renderWeightChangeTable() {
        const getRows = () => {
            return Selectors.getRows(this.state);
        }
        const getSize = () => {
            return getRows().length;
        }
        const rowGetter = rowIdx => {
            var rows = getRows();
            return rows[rowIdx];
        }
        const handleRowUpdated = e => {
            this.setState({ sortColumn: null, sortDirection: null })
            let rows = getRows();

            let editedRows = this.state.editedRows.slice(0);
            Object.assign(rows[e.rowIdx], e.updated);
            editedRows.forEach((element, index) => {
                if (element.Idx === rows[e.rowIdx].Idx)
                    editedRows.splice(index, 1)
            }, this);
            editedRows.push(rows[e.rowIdx]);
            if (e.cellKey === 'carrier') {
                const carrier = vakLogisticCarrierOptions.find(option => option.value === e.updated[e.cellKey])
                rows[e.rowIdx].Dimensions = carrier.size || '';
                rows[e.rowIdx].isCustomSize = !!carrier.size;
                rows[e.rowIdx].signature = 'none';
            }
            if (e.cellKey === 'Dimensions' && e.updated[e.cellKey] === 'other') {
                rows[e.rowIdx].isCustomSize = true;
                rows[e.rowIdx].Dimensions = '';
            }
            if (e.cellKey !== 'price' && e.cellKey !== 'Package_Note') {
                rows[e.rowIdx].price = 0;
            }
            if (e.cellKey !== 'Package_Weight') {
                rows[e.rowIdx].Package_Weight = this.getRowWeight(rows[e.rowIdx]);
            }
            if (e.cellKey == 'insurance') {
                if(e.updated.insurance == 'None') {
                    rows[e.rowIdx].insure_amount = '';
                } else {
                    rows[e.rowIdx].insure_amount = this.getRowPrice(rows[e.rowIdx]);
                }
            }
            if (e.cellKey == 'signature') {
                rows[e.rowIdx].signature = e.updated.signature;
            }
            this.setState({
                rows: cloneDeep(rows),
                editedRows: cloneDeep(editedRows),
                sumShippingWeight: this.getTotalShippingWeight(rows),
            });
        }
        // const onRowsSelected = (rows) => {
        //     let newRows = getRows();
        //     newRows.map(r => {
        //         r.isSelected = false;
        //     })
        //     rows.map(r => {
        //         newRows[r.rowIdx].isSelected = true;
        //     });
        //     this.setState({ rows: newRows, selectedRows: [rows[0].row] });
        // }
        const onRowsSelected = (rows) => {
            let newRows = getRows();
            let selectedRows = [...this.state.selectedRows];
            rows.map(r => {
                newRows[r.rowIdx].isSelected = true;
                selectedRows.push(r.row);
            });
            this.setState({ rows: newRows, selectedRows });
        }
        // const onRowsDeselected = (rows) => {
        //     let newRows = getRows();
        //     rows.map(r => {
        //         newRows[r.rowIdx].isSelected = false;
        //     });
        //     this.setState({ rows: newRows, selectedRows: [] });
        // }
        const onRowsDeselected = (rows) => {
            let newRows = [...this.state.rows];
            let selectedRows = [...this.state.selectedRows];
            rows.map((r) => {
                newRows[r.rowIdx].isSelected = false;
                const rowIndex = selectedRows.indexOf(r.row);
                selectedRows.splice(rowIndex, 1);
            });
            this.setState({ rows: newRows, selectedRows });
        }

        const columns = [
            {
                key: 'Package_Weight',
                name: <Translate value="weight_lbs" />,
                resizable: true,
                sortable: true,
                filterable: true,
                editable: row => !row.Tracking_Number,
                width: 100,
                getRowMetaData: row => row,
                formatter: ({dependentValues, value}) => {
                    if (isVAK) {
                        let boxWeight = 0;
                        if (dependentValues.Dimensions) {
                            const box = concat(vakDimensionsOptions, vakLogisticCarrierOptions).find(option => dependentValues.Dimensions === option.size);
                            boxWeight = box && box.weight || 0;
                        }
                        return <span>{roundToDecimals(parseFloat(value || 0) + boxWeight)}</span>
                    }
                    return <span>{value}</span>
                }
            },
            {
                key: 'Tracking_Number',
                name: <Translate value="tracking_num" />,
                resizable: true,
                sortable: true,
                filterable: true,
                width: 150,
                editable: row => isVAK && !row.Tracking_Number,
            },
            {
                key: 'Package_Note',
                name: <Translate value="note" />,
                resizable: true,
                sortable: true,
                filterable: true,
                width: 250,
                editable: row => !row.Tracking_Number,
            },
        ]
        if(isVAK) {
            const weightIndex = columns.findIndex(column => column.key === 'Package_Weight');
            if (weightIndex !== -1) {
                columns.splice(weightIndex, 0, {
                    key: 'carrier',
                    name: <Translate value="carrier" />,
                    resizable: true,
                    editable: row => !row.Tracking_Number,
                    width: 200,
                    editor: <DropDownEditor options={vakLogisticCarrierOptions} />,
                    formatter: ({value}) => {
                        if (value) {
                            const carrier = vakLogisticCarrierOptions.find(option => option.value === value);
                            return <span>{carrier && carrier.text}</span>
                        }
                        return <span />
                    }
                }, {
                    key: 'Dimensions',
                    name: <Translate value="package_size" />,
                    resizable: true,
                    editable: row => !row.Tracking_Number,
                    width: 150,
                    editor: <CustomEditor />,
                }, {
                    key: 'Product_Details',
                    name: <Translate value="product_details" />,
                    resizable: true,
                    width: 200,
                    getRowMetaData: row => row,
                    formatter: ({ dependentValues, value }) => {
                        const productDetailsText = JSON.parse(value || '[]').map(product => product.RefNum + ' x ' + product.Quantity).join(',');
                        return <div onDoubleClick={() => this.openProductModal(dependentValues)} style={{width: '100%', height: 25}}>
                            {productDetailsText}
                        </div>
                    }
                });
            }
            const trackingIndex = columns.findIndex(column => column.key === 'Tracking_Number');
            if (trackingIndex !== -1) {
                columns.splice(trackingIndex, 0, {
                   key: 'price',
                   name: <Translate value="price" />,
                   resizable: true,
                   width: 100,
                   getRowMetaData: row => row,
                   formatter: ({ dependentValues, value}) => {
                       if (!value && !dependentValues.Tracking_Number) {
                           return <Button
                             bsStyle={'success'}
                             onClick={() => this.handleGetLogisticPrice(dependentValues)}
                             disabled={!dependentValues.carrier || !dependentValues.Dimensions || !dependentValues.Package_Weight || this.state.isLoadingPrice}
                           ><Translate value={"show_price"}/>
                           </Button>
                       }
                       return <span>{value && value != 0 ? '$' + value : ''}</span>
                   }
                });

                columns.splice((trackingIndex+1), 0, {
                    key: 'insurance',
                    name: <Translate value="insurance" />,
                    resizable: true,
                    editable: row => !!row.Product_Details && !row.Tracking_Number,
                    width: 150,
                    editor: <DropDownEditor options={vakInsuranceOptions} />,
                    formatter: ({value}) => {
                        if (value) {
                            const insurance = vakInsuranceOptions.find(option => option.value === value);
                            return <span>{insurance && insurance.text}</span>
                        }
                        return <span />
                    }
                 },);
                 columns.splice((trackingIndex+2), 0, {
                    key: 'insure_amount',
                    name: <Translate value="insure_amount" />,
                    resizable: true,
                    width: 100,
                    editable: row => !!row.insurance && row.insurance != 'None' && !row.Tracking_Number,
                 },);
                 columns.splice((trackingIndex+3), 0, {
                    key: 'signature',
                    name: <Translate value="signature" />,
                    resizable: true,
                    editable: row => !!row.carrier && !row.Tracking_Number,
                    width: 150,
                    getRowMetaData: row => row,
                    editor: <SignatureEditor/>,
                    formatter: ({value, dependentValues}) => {
                        if (value) {
                            const signature = (dependentValues.carrier && dependentValues.carrier.indexOf('usps') != -1? vakUspsSignatureOptions:vakFedexSignatureOptions).find(option => option.value === value);
                            return <span>{signature && signature.text}</span>
                        }
                        return <span />
                    }
                 },);
            }
        }

        return (
            <Row>
                <Col>
                    <div style={{ maxWidth: isVAK? '980px' :'580px', marginLeft: '25px' }}>
                        <ReactDataGrid
                            // rowKey="Idx"
                            enableCellSelect={true}
                            columns={columns}
                            rowGetter={rowGetter}
                            rowsCount={getSize()}
                            minHeight={isVAK ? 300 : 150}
                            rowHeight={25}
                            headerRowHeight={45}
                            enableRowSelect='single'
                            onRowUpdated={handleRowUpdated}
                            rowSelection={{
                                showCheckbox: true,
                                onRowsSelected,
                                onRowsDeselected,
                                selectBy: {
                                    isSelectedKey: 'isSelected'
                                }
                            }}
                        />
                    </div>
                </Col>
            </Row>
        )
    }
    openProductModal = ({
        Idx, ...row
    }) => {
        if (!row.Tracking_Number) {
            this.setState({
                productModalVisibility: true,
                productImportRowIdx: Idx,
                productImportRow: row,
            })
        }
    }
    handleProductConfirm = productRows => {
        const rows = this.state.rows;
        if (this.state.productImportRowIdx !== null) {
            rows[this.state.productImportRowIdx].Product_Details = JSON.stringify(productRows.map(row => ({
                SalesOrderLine_id: row.SalesOrderLine_id,
                Product_id: row.Product_id,
                RefNum: row.RefNum,
                Quantity: +row.ShippedQuantity,
                NetWeight: +row.NetWeight,
            })));
            rows[this.state.productImportRowIdx].Package_Weight = this.getRowWeight(rows[this.state.productImportRowIdx]);
            rows[this.state.productImportRowIdx].price = 0;
            if(rows[this.state.productImportRowIdx].insurance && rows[this.state.productImportRowIdx].insurance !== 'None') {
                rows[this.state.productImportRowIdx].insure_amount = this.getRowPrice(rows[this.state.productImportRowIdx]);
            }
            this.setState({
                rows: [...rows],
                sumShippingWeight: this.getTotalShippingWeight(rows),
            });
        }
        this.closeProductModal();
    }
    closeProductModal = () => {
        this.setState({
            productModalVisibility: false,
            productImportRowIdx: null,
            productImportRow: null,
        })
    }

    render() {
        const {
            finalShippingWeight,
            currentSalesOrder,
            isMobile,
        } = this.props;

        const {
            sumShippingWeight,
            isMin,
        } = this.state;
        const createProductDialogStyle = {
            width: '820px',
            height: '300px',
            marginLeft: '-24%'
        }
        let isEmpty = true;
        this.state.rows.map(item => {
            let dim = false;
            let wt = false;
            let prd = false;
            if(item.Dimensions) {
                dim = true;
            }
            if(item.Package_Weight) {
                wt = true;
            }
            if(item.Product_Details.length > 2) {
                prd = true;
            }
            if(dim && wt && prd) {
                isEmpty = false;
            }
        })

        let isPrintDisabled = isVAK && (isEmpty || this.state.selectedRows.length == 0 || this.state.selectedRows.findIndex(r => !r.id) != -1);
        let isEditDisabled = isVAK && currentSalesOrder.IsShipped;
        return (
            <div>
                <ButtonToolbar style={{ marginLeft: '5px', marginBottom: '7px' }}>
                    <Button
                        bsStyle="primary"
                        onClick={(event) => { this.clickNew(event) }}
                        disabled={isEditDisabled}
                    >
                        <em className="fa fa-plus marginRightStyle" /><Translate value="package" />
                    </Button>
                    <Button
                        style={{ marginRight: '5px' }}
                        bsStyle="danger"
                        onClick={(event) => { this.deleteCategory(event) }}
                        disabled={!this.state.selectedRows || this.state.selectedRows.length != 1 || isEditDisabled}
                    ><em className="fa fa-trash marginRightStyle" /><Translate value="delete" />
                    </Button>
                    {isVAK && <Button
                        bsStyle="primary"
                        onClick={(event) => { 
                            let showMin = !this.state.isMin;
                            this.setState({isMin:showMin});
                            this.props.minOrMax(showMin);
                        }}
                    ><em className={isMin ? "fa fa-square-o" : "fa fa-minus"} />
                    </Button>}
                    {/* <Input type="text" style={{ width: '100px' }} value={sumShippingWeight + ' lbs'} disabled={true} /> */}
                </ButtonToolbar>
                {!isMin && <Row>
                    <Col className="text-center">
                        <span>
                            {this.renderWeightChangeTable()}
                        </span>
                    </Col>
                </Row>}
                {!isMin && <Row sm={8}>
                    <Col sm={4}>
                        <Row style={{ marginLeft: '5px', marginTop: '5px' }}>
                            <Col sm={10}>
                                <label><Translate value="total_shipping_weight_lbs" />:</label>
                            </Col>
                        </Row>
                        <Row style={{ marginLeft: '5px' }}>
                            <Col sm={10}>
                                <Input
                                type="number"
                                // value={finalShippingWeight}
                                value={sumShippingWeight}
                                onChange={this.props.onChange}
                                disabled={true}
                                />
                            </Col>
                        </Row>
                    </Col>
                    {isMobile && <Col sm={4}>
                        <Row style={{ marginLeft: '5px', marginTop: '5px' }}>
                            <Col sm={4}>
                                <label><Translate value="unfreeze" />:</label>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={2}>
                                <Input type='checkBox' onChange={(event)=>{
                                    this.setState({isUnfreeze:event.target.checked});
                                }}/>
                            </Col>
                        </Row>
                    </Col>}
                </Row>}
                {!isMin && <Row className="centerStyle" style={{ marginTop: '0px' }}>
                    <Button
                        style={{ marginRight: '5px' }}
                        bsStyle="primary"
                        onClick={(e) => { this.handleOnSave(e); }}
                    >
                        <Translate value="save" />
                    </Button>
                    {!isVAK && <Button
                        style={{ marginRight: '5px' }}
                        bsStyle="success"
                        disabled={isPrintDisabled}
                        onClick={(e) => { this.handleOnSavePrint(e); }}
                    >
                        <Translate value="save_and_print" />
                    </Button>}
                    <Button
                        style={{ marginRight: '5px' }}
                        bsStyle="success"
                        disabled={isPrintDisabled}
                        onClick={(e) => { 
                            if(isVAK) {
                                this.handlePrint(e);
                                return
                            }
                            this.handleOnSavePrint(e); }}
                    >
                        <Translate value={isVAK ? isEditDisabled ? 're_print' : 'print' 
                            : "save_and_print"} />
                    </Button>
                    {!isVAK && <Button
                        bsStyle="success"
                        onClick={(e) => { this.handleOnRecreate(e); }}
                        disabled={!this.state.selectedRows || this.state.selectedRows.length < 1}
                    >
                        <Translate value="recreate" />
                    </Button>}
                    {isVAK && <Button
                        bsStyle="success"
                        onClick={(e) => { this.handlePackingPrint(e); }}
                        disabled={isPrintDisabled}
                    >
                        <Translate value="packing" />
                    </Button>}
                </Row>}
                <SkyLightStateless dialogStyles={createProductDialogStyle} isVisible={this.state.productModalVisibility} onCloseClicked={() => { this.closeProductModal(); }} title={<Translate value={"choose_product"} />}>
                    <WeightChangeChooseProduct productRow={this.state.productImportRow} onConfirm={this.handleProductConfirm} />
                </SkyLightStateless>
            </div>
        );
    }
}

export default WeightChangeModalMulti;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/weightChangeModalMulti.jsx